<template>
  <HeaderApp />
  <div class="mt-14"></div>

  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      (isHide == true
        ? '  '
        : $store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
    id="printDev"
  >
    <InvoiceHeader invoice_type="expire_items_list" v-if="isHide == true" />
    
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("expire_items_list") }}
      </h1>
    </div>

    <!-- Table Section -->
    <div class="px-6 py-4">
      <div class="relative overflow-x-auto">
        <div class="flex items-center justify-between pb-4 no-print">
          <div class="flex items-center space-x-4">
            <BaseInput
              :modelValue="$store.state.expire_item.search"
              @update:modelValue="handleSearchInput"
              :placeholder="$t('search')"
              :prefixIcon="'fa-solid fa-search'"
              class="w-40 md:w-full"
            /> <button
              class="mx-2 my_font bg-primaryColor hover:bg-blue-700 text-white font-bold py-1 px-4 rounded no-print"
              @click="printReportFunc"
              id="button_print"
              v-if="$store.getters['checkPrintAccess']"
            >
              {{ $t("print") }}
            </button>
          </div>
          
          <!-- Column Selection and Controls -->
          <div class="flex items-center space-x-4">
            <CustomMultiSelect
              v-model="selectedHeaders"
              :options="headers"
              track-by="value"
              label="text"
              :placeholder="$t('columns')"
              :header-text="$t('which_columns_to_display')"
              @update:modelValue="printCall"
            />
            <div class="w-0.5"></div>
            <button
              @click="resetToDefaultHeaders"
              class="group inline-flex items-center justify-center w-10 h-10 bg-gradient-to-br  text-blue-600 dark:text-blue-400 rounded-xl border border-blue-200 dark:border-gray-600 hover:from-blue-100 hover:to-indigo-200 dark:hover:from-gray-600 dark:hover:to-gray-700 hover:shadow-lg hover:shadow-blue-200/50 dark:hover:shadow-gray-900/50 hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 backdrop-blur-sm"
              :title="$t('reset_to_default')"
            >
              <i class="fa fa-refresh text-sm group-hover:rotate-180 transition-transform duration-500"></i>
            </button>
           
          </div>
        </div>
        <!--in ltr change (text-right to text-left)
        <EasyDataTable
          :headers="headers"
          :items="filterItems"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          alternating
          :header-props="{ 'sort-icon': 'fa-solid fa-arrow-up-wide-short' }"
          :loading="isLoadingData"
          :class="isDark ? 'customize-table ' : 'light-mode-table'"
        >
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <a class="mx-1" :href="'item-detail/' + item.i_id">
              <i
                class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </a> </template
          ><template #item-currency_cur_name="item">
            {{ $t(item.currency.cur_name) }} </template
          ><template #item-i_image="item">
            <img
              :src="file_url + item.i_image"
              class="inline-flex items-center justify-center ml-4 text-white transition-all duration-200 ease-in-out text-size-sm h-16 w-16 rounded-xl"
              alt="xd"
              v-if="item.i_image"
              @click="openModal(file_url + item.i_image)"
            />
            <span v-if="item.i_image == '' || item.i_image == null">
              <i class="fa-solid fa-image text-primaryColor"></i>
            </span>
          </template>
          <template #item-i_expire_date="item">
            <span
              class="bg-warning text-white px-3 py-1 rounded"
              v-show="!checkIfExpiredDate(item)"
            >
              {{ item.i_expire_date }}</span
            ><span
              class="bg-red-500 text-white px-3 py-1 rounded"
              v-show="checkIfExpiredDate(item)"
            >
              {{ item.i_expire_date }}</span
            >
          </template>
          <template #loading>
            <div class="flex flex-col items-center justify-center py-8">
              <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
              <p class="text-gray-500 dark:text-gray-400 text-sm">{{ $t('loading') }}...</p>
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }} </template
          >          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12">
              <i class="fa-solid fa-inbox text-4xl text-gray-400 dark:text-gray-600 mb-4"></i>
              <p class="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">{{ $t("no_data_found") }}</p>
              <p class="text-sm text-gray-500 dark:text-gray-400">{{ $t("try_adjusting_your_search_criteria") }}</p>
            </div>
          </template>
          <template
            #pagination="{ prevPage, nextPage, isFirstPage, isLastPage }"
          >
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-right'
                    : ' fa-chevron-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-chevron-left'
                    : ' fa-chevron-right')
                "
              ></i>
            </button>
          </template>
        </EasyDataTable>
      -->
        <EasyDataTable
          v-model:server-options="serverOptions"
          :headers="showHeaders"
          :items="items"
          :server-items-length="serverItemsLength"
          :loading="isLoadingData"
          :alternating="false"
          :buttons-pagination="true"
          :body-text-direction="$store.getters['isRtl'] ? 'right' : 'left'"
          :hide-footer="isHide"
          :rows-items="[25, 50, 100, serverItemsLength]"
          rows-per-page="10"
          :table-class-name="isDark ? 'modern-dark-table' : ''"
        >
          <template #default="{ column, sortDirection }">
            <div :class="`flex items-center space-x-2 ${$store.getters['isRtl'] ? 'justify-end' : 'justify-start'}`">
              <span class="font-semibold text-gray-700 dark:text-gray-300">{{ column.label }}</span>
              <span v-if="column.sortable" class="text-gray-400">
                <i
                  v-if="sortDirection === 'asc'"
                  class="fa-solid fa-arrow-up text-blue-500"
                ></i>
                <i
                  v-else-if="sortDirection === 'desc'"
                  class="fa-solid fa-arrow-down text-blue-500"
                ></i>
                <i v-else class="fa-solid fa-arrows-up-down"></i>
              </span>
            </div>
          </template>
          <template #item-actions="item">
            <a
              class="mx-1 my-1"
              target="_blank"
              :href="'item-detail/' + item.i_id"
              v-if="
                $store.getters['checkUserAccess']({
                  id: '8',
                  action: 'detail',
                })
              "
            >
              <i
                class="m-1 fa-solid fa-eye text-center p-1 w-7 h-7 text-sm bg-green-200 dark:bg-blue-300 rounded-md text-green-500 mx-auto"
              >
                {{ item.text }}
              </i>
            </a> </template
          ><template #item-currency_cur_name="item">
            {{ $t(item.currency.cur_name) }} </template
          ><template #item-i_image="item">
            <img
              :src="file_url + item.i_image"
              class="inline-flex items-center justify-center ml-4 text-white transition-all duration-200 ease-in-out text-size-sm h-16 w-16 rounded-xl"
              alt="xd"
              v-if="item.i_image"
              @click="openModal(file_url + item.i_image)"
            />
            <span v-if="item.i_image == '' || item.i_image == null">
              <i class="fa-solid fa-image text-primaryColor"></i>
            </span>
          </template>
          <template #item-i_expire_date="item">
            <span
              class="bg-warning text-white px-3 py-1 rounded"
              v-show="!checkIfExpiredDate(item)"
            >
              {{ item.i_expire_date }}</span
            ><span
              class="bg-red-500 text-white px-3 py-1 rounded"
              v-show="checkIfExpiredDate(item)"
            >
              {{ item.i_expire_date }}</span
            >
          </template>
          <template #loading>
            <div class="flex flex-col items-center justify-center py-8">
              <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
              <p class="text-gray-500 dark:text-gray-400 text-sm">{{ $t('loading') }}...</p>
            </div>
          </template>
          <template #item-created_at="item">
            {{ formatDate(item.created_at) }} </template
          >          <template #empty-message>
            <div class="flex flex-col items-center justify-center py-12">
              <i class="fa-solid fa-inbox text-4xl text-gray-400 dark:text-gray-600 mb-4"></i>
              <p class="text-lg font-medium text-gray-700 dark:text-gray-300 mb-2">{{ $t("no_data_found") }}</p>
              <p class="text-sm text-gray-500 dark:text-gray-400">{{ $t("try_adjusting_your_search_criteria") }}</p>
            </div>
          </template>
          <template
            #pagination="{
              prevPage,
              nextPage,
              isFirstPage,
              isLastPage,
              currentPaginationNumber,
              maxPaginationNumber,
            }"
          >
            <button :disabled="isFirstPage" @click="goToPage(1)">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-right'
                    : ' fa-angle-double-left')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button :disabled="isFirstPage" @click="prevPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-right'
                    : ' fa-angle-left ')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              v-for="page in getVisiblePages(
                currentPaginationNumber,
                maxPaginationNumber
              )"
              :key="page"
              @click="goToPage(page)"
              :class="getPageButtonClasses(page, currentPaginationNumber)"
            >
              {{ page }}
            </button>

            <div class="w-5"></div>
            <button :disabled="isLastPage" @click="nextPage">
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-left'
                    : ' fa-angle-right')
                "
              ></i>
            </button>
            <div class="w-5"></div>
            <button
              :disabled="isLastPage"
              @click="goToPage(maxPaginationNumber)"
            >
              <i
                :class="
                  'fa-sharp fa-solid ' +
                  ($store.getters['isRtl']
                    ? ' fa-angle-double-left'
                    : ' fa-angle-double-right')
                "
              ></i>
            </button> </template
        ></EasyDataTable>
      </div>
    </div>
  </div>
  <image-modal ref="imageModal" />
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import CustomMultiSelect from "../../components/Inputs/CustomMultiSelect.vue";
import { FILE_URL } from "../../constants/config";
import { formatDate } from "../../utils/functions";
import ImageModal from "../../components/Modals/ImageModal2.vue";
import InvoiceHeader from "../../components/Navbar/InvoiceHeader.vue";
import "../../assets/css/modern-table.css";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    CustomMultiSelect,
    ImageModal,
    InvoiceHeader,
  },
  data() {
    return {
      isSubmited: false,
      isSubmitedEdit: false,
      file_url: FILE_URL,
      current: {},
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 12,
      },
      loading: false,
      items: [],
      isHide: false,
      selectedHeaders: [],
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.note.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.note.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("note/SET_DELETE_SUCCESS", false);
      }
    },
    serverOptions: {
      handler() {
        this.loadFromServer();
      },
      deep: true,
    },
  },
  mounted() {
    // First load when the component is mounted
    this.loadFromServer();
    this.loadSelectedHeaders();
  },
  computed: {
    filterItems() {
      return this.$store.getters["expire_item/filterItems"];
    },
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isLoadingData() {
      return this.$store.state.expire_item.isLoadingData;
    },
    isBtnLoading() {
      return this.$store.state.expire_item.isBtnLoading;
    },
    isBtnEditLoading() {
      return this.$store.state.expire_item.isBtnEditLoading;
    },

    headers() {
      var listHeader = [
        { text: this.$t("actions"), value: "actions", sortable: false },
        { text: this.$t("item_barcode"), value: "i_barcode", sortable: true },
        { text: this.$t("item_name"), value: "i_name", sortable: true },
        {
          text: this.$t("photo"),
          value: "i_image",
          sortable: true,
        },
        {
          text: this.$t("item_category"),
          value: "category.ca_name",
          sortable: true,
        },

        {
          text: this.$t("item_quantity_in_storage"),
          value: "i_quantity",
          sortable: true,
        },
        {
          text: this.$t("item_bought_quantity_till_now"),
          value: "i_in_quantity",
          sortable: true,
        },
        {
          text: this.$t("item_sold_quantity_till_now"),
          value: "i_out_quantity",
          sortable: true,
        },

        {
          text: this.$t("item_expire_date"),
          value: "i_expire_date",
          sortable: true,
        },
        { text: this.$t("note"), value: "i_desc", sortable: true },
        { text: this.$t("admin"), value: "users.name", sortable: true },
        { text: this.$t("created_at"), value: "created_at", sortable: true },
      ];
      //remove created_at,id,actions if isHide = true
      if (this.isHide == true) {
        listHeader = listHeader.filter(
          (item) =>
            item.value != "created_at" &&
            item.value != "actions" &&
            item.value != "users.name"
        );
      }
      return listHeader;
    },
    showHeaders() {
      var temp = [];
      //cretae a for check all selectedHeaders add to temp
      for (let i = 0; i < this.selectedHeaders.length; i++) {
        for (let j = 0; j < this.headers.length; j++) {
          if (this.selectedHeaders[i].text == this.headers[j].text) {
            temp.push(this.headers[j]);
          }
        }
      }

      if (temp.length == 0) {
        temp = this.headers;
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedHeaders = temp;
      }

      return temp;
    },
  },

  methods: {
    handleSearchInput(value) {
      this.$store.commit('expire_item/SET_SEARCH', value);
      this.loadFromServer();
      this.serverOptions.page = 1;
    },
    loadSelectedHeaders() {
      // Load selected headers from localStorage
      const savedHeaders = localStorage.getItem("expireItemSelectedHeaders");
      if (savedHeaders) {
        try {
          const parsedHeaders = JSON.parse(savedHeaders);
          // Filter to only include headers that exist in current headers list
          this.selectedHeaders = this.headers.filter((header) =>
            parsedHeaders.some((saved) => saved.value === header.value)
          );
        } catch (error) {
          console.error("Error loading saved headers:", error);
          this.selectedHeaders = [...this.headers];
        }
      } else {
        // If no saved headers, select all by default
        this.selectedHeaders = [...this.headers];
      }
    },
    saveSelectedHeaders() {
      // Save selected headers to localStorage
      try {
        localStorage.setItem(
          "expireItemSelectedHeaders",
          JSON.stringify(this.selectedHeaders)
        );
      } catch (error) {
        console.error("Error saving headers:", error);
      }
    },
    printCall(selectedHeaders) {
      // Handle column selection changes
      if (selectedHeaders && Array.isArray(selectedHeaders)) {
        this.selectedHeaders = selectedHeaders;
        this.saveSelectedHeaders();
      }
    },
    resetToDefaultHeaders() {
      // Reset to select all headers
      this.selectedHeaders = [...this.headers];
      this.saveSelectedHeaders();
    },
    printReportFunc() {
      this.isHide = true;
      //wait 1 second
      setTimeout(() => {
        var printContents = document.getElementById("printDev").innerHTML;

        // Replace the body's innerHTML with the print contents
        document.body.innerHTML = printContents;
        var isRtl = this.$store.getters["isRtl"];
        // Set direction based on the parameter
        if (isRtl) {
          document.body.style.direction = "rtl";
        } else {
          document.body.style.direction = "ltr";
        }

        // Print the content
        window.print();
         // Adjust the timeout as needed
        //reload page
      }, 100);
      //print element id invoice_print
    },
    getVisiblePages(currentPage, totalPages) {
      const numVisibleButtons = 3; // Adjust this number based on your design preference
      const pages = [];

      // Display pages 1 to numVisibleButtons (e.g., 1, 2, 3)
      if (currentPage <= Math.floor(numVisibleButtons / 2) + 1) {
        for (let i = 1; i <= Math.min(totalPages, numVisibleButtons); i++) {
          pages.push(i);
        }
      }
      // Display pages around the current page (e.g., 1, ..., 10, ..., 20)
      else {
        const startPage = Math.max(
          1,
          currentPage - Math.floor(numVisibleButtons / 2)
        );
        const endPage = Math.min(totalPages, startPage + numVisibleButtons - 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
      }

      return pages;
    },

    // Function to get Tailwind CSS classes for each page button
    getPageButtonClasses(page, currentPage) {
      return {
        "bg-blue-500 text-white": page === currentPage,
        "bg-gray-300 text-gray-700 hover:bg-gray-400": page !== currentPage,
        "p-2 rounded-md mx-1": true, // Adjust padding and rounding based on your design
      };
    },

    goToPage(page) {
      // Implement your logic to update the current page
      //update page
      this.serverOptions.page = page;
      this.loadFromServer();
    },
    async loadFromServer() {
      this.loading = true;

      var tempObj = { ...this.serverOptions };
      //add new field to object search
      tempObj.search = this.$store.state.expire_item.search;

      const res = await this.$store.dispatch("expire_item/getItems", tempObj);

      this.items = res.data.data;
      this.serverItemsLength = res.data.total;
      this.loading = false;
    },
    openModal(image) {
      this.$refs.imageModal.show(image);
    },
    formatDate(date) {
      return formatDate(date);
    },

    checkIfExpiredDate(item) {
      let today = new Date();
      let expireDate = new Date(item.i_expire_date);
      if (today > expireDate) {
        return true;
      }
      return false;
    },
  },
};
</script>
